<template>
  <div>
    <a-button type="primary" @click="goTo">添加菜单</a-button>
    <a-table
      :columns="columns"
      bordered
      :row-key="(item) => item.uid"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="operate" slot-scope="text, operate">
        <a href="javascript:;" @click="del(operate)">删除</a>
      </template></a-table
    >
  </div>
</template>
<script>
import { menuPagination, delMenu } from "@/api/testApi.js";
import { message } from "ant-design-vue";

const columns = [
  {
    title: "菜单名称",
    dataIndex: "name",
  },
  {
    title: "component",
    dataIndex: "component",
  },
  {
    title: "objId",
    dataIndex: "objId",
  },
  {
    title: "level",
    dataIndex: "level",
  },
  {
    title: "上级菜单",
    dataIndex: "parentId",
  },
  {
    title: "是否为商家菜单",
    dataIndex: "shop",
  },
  {
    title: "菜单路径",
    dataIndex: "path",
  },
  {
    title: "前端图标",
    dataIndex: "icon",
  },
  {
    title: "排序",
    dataIndex: "sort",
  },
  {
    title: "操作",
    dataIndex: "operate",
    scopedSlots: { customRender: "operate" },
  },
];
export default {
  data() {
    return {
      path: "",
      name: "",
      icon: "",
      objId: "",
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      data: [],
      columns,
      visible: false,
    };
  },
  created() {
    this.getMenuPagination();
  },
  methods: {
    goTo() {
      this.$router.push("/home/right2");
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      menuPagination({ limit: 10, page: this.pagination.current }).then(
        (res) => {
          this.data = res.data;
          console.log(res);
        }
      );
      this.loading = false;
    },
    getMenuPagination() {
      menuPagination({ limit: 10, page: 1 }).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    del(row) {
      delMenu(row.objId).then(() => {
        message.success("删除成功");
        this.getMenuPagination();
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/right/right1.vue